import { DynField } from "./dyn-field";
import { Entity } from "../../../core/commons/entity";
import { Ministry } from "app/profile/domain/ministry/ministry";
import {FormImage} from "./form-image";

export class DynForm implements Entity {
  id: number;
  name: string;
  referenceNumber: string;
  private version: number;
  private description: string;
  private subform: boolean;
  private state: string;
  private validSince: number;
  private validUntil: number;
  private fields: Array<DynField> = null;
  private ministry: Ministry;
  image: FormImage;
  /*
    public static createFromObject(object: Object): DynForm {
        const form = new DynForm();
        form.updateFromObject(object);
        return form;
    }
    */

  public constructor(
    id: number = null,
    name = "Formulario sin título",
    version = 1,
    description = "",
    referenceNumber = "",
    subform = false,
    state = "CREATED",
    fields = [],
    ministry: Ministry = null
  ) {
    this.id = id;
    this.name = name;
    this.version = version;
    this.description = description;
    this.referenceNumber = referenceNumber;
    this.subform = subform;
    this.state = state;
    this.fields = fields;
    this.ministry = ministry;
  }

  getId(): number {
    return this.id;
  }

  setId(value: number) {
    this.id = value;
  }

  getName(): string {
    return this.name;
  }

  setName(value: string) {
    this.name = value;
  }

  getVersion(): number {
    return this.version;
  }

  setVersion(version: number) {
    this.version = version;
  }

  getDescription(): string {
    return this.description;
  }

  setDescription(value: string) {
    this.description = value;
  }

  getReferenceNumber(): string {
    return this.referenceNumber;
  }

  setReferenceNumber(value: string) {
    this.referenceNumber = value;
  }
  
  getSubform(): boolean {
    return this.subform;
  }

  setSubform(value: boolean) {
    this.subform = value;
  }

  getState(): string {
    return this.state;
  }

  setState(value: string): void {
    this.state = value;
  }

  getStateString(): string {
    switch (this.state) {
      case "CREATED":
        return "No Publicado";
      case "PUBLISHED":
        return "Publicado";
      case "DISABLED":
        return "Deshabilitado";
    }
  }

  getValidSince(): number {
    return this.validSince;
  }

  setValidSince(value: number): void {
    this.validSince = value;
  }

  getValidUntil(): number {
    return this.validUntil;
  }

  setValidUntil(value: number) {
    this.validUntil = value;
  }

  getFields(): Array<DynField> {
    return this.fields;
  }

  setFields(value: Array<DynField>) {
    this.fields = value;
  }

  getMinistry(): Ministry {
    return this.ministry;
  }

  setMinistry(ministry: Ministry) {
    this.ministry = ministry;
  }

  getMinistryName(): string {
    let name: string = "-";
    if (this.ministry != null) name = this.ministry.name;
    return name;
  }

  public getFieldByName(name: string) {
    return this.getFields().find(f => f.getName() === name);
  }
  /*
    protected updateFromObject(object: Object) {
        this._id = object['id'];
        this._name = object['name'];
        this._description = object['description'];
        this._subform = object['subform'];
        this._fields = object['fields'].map(f => DynField.createFromObject(f))
    }
*/
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/dyn-form.ts